class ScrollTxt {
  constructor() {
    this.containers = document.querySelectorAll('.js-scroll-txt-container');
    this.activeClassName = 'is-active';
    this.textTriggerRatio = 0.5;        // テキストフェードインのトリガーライン（上から50%）
    // this.layerBottomTriggerRatio = 0.1; // layer下端トリガーライン（下から10%）
    this.staggerDelay = 1500;            // 一括アクティブ化時の要素ごとの遅延（ms）
    this.init();
  }

  init() {
    if (!this.containers.length) return;
    this.containers.forEach((container) => {
      this.initStickyLayer(container);
      this.observeContainerStart(container);
    });
  }

  observeContainerStart(container) {
    const els = Array.from(container.querySelectorAll('[data-scroll-txt]'));
    if (!els.length) return;

    let started = false;
    const triggerLine = () => window.innerHeight * this.textTriggerRatio;

    const start = () => {
      if (started) return;
      const top = container.getBoundingClientRect().top;
      if (top > triggerLine()) return;

      started = true;
      window.removeEventListener('scroll', onUpdate);
      window.removeEventListener('resize', onUpdate);
      this.startStaggerWithVisibility(els);
    };

    const onUpdate = () => start();
    window.addEventListener('scroll', onUpdate, { passive: true });
    window.addEventListener('resize', onUpdate, { passive: true });
    start();
  }

  startStaggerWithVisibility(els) {
    els.forEach((el, i) => {
      setTimeout(() => this.activateWhenVisible(el), this.staggerDelay * i);
    });
  }

  activateWhenVisible(el) {
    if (el.classList.contains(this.activeClassName)) return;

    const rect = el.getBoundingClientRect();
    const inView = rect.bottom > 0 && rect.top < window.innerHeight;
    if (inView) {
      this.activate(el);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        this.activate(entry.target);
        observer.unobserve(entry.target);
        observer.disconnect();
      });
    }, { threshold: 0 });

    observer.observe(el);
  }

  // テキストフェードイン用の IntersectionObserver を生成する
  // ビューポート上端から textTriggerRatio の位置でトリガー
  // createTextObserver() {
  //   const observer = new IntersectionObserver(
  //     (entries) => {
  //       entries.forEach((entry) => {
  //         if (entry.isIntersecting) {
  //           this.activate(entry.target);
  //           // 一度発火したら監視を解除
  //           observer.unobserve(entry.target);
  //         }
  //       });
  //     },
  //     { rootMargin: `0px 0px -${(1 - this.textTriggerRatio) * 100}% 0px`, threshold: 0 }
  //   );
  //   return observer;
  // }

  // data-scroll-txt 属性要素を監視してフェードイン表示する
  // observeTextElements(container) {
  //   const els = container.querySelectorAll('[data-scroll-txt]');
  //   if (!els.length) return;

  //   // 最初の要素は初期表示でアクティブ化
  //   this.activate(els[0]);
  //   if (els.length <= 1) return;

  //   // すでにトリガーラインを超えている要素は即時アクティブ化、それ以外は IO で監視
  //   const triggerLine = window.innerHeight * this.textTriggerRatio;
  //   const observer = this.createTextObserver();
  //   Array.from(els).slice(1).forEach((el) => {
  //     if (el.getBoundingClientRect().top <= triggerLine) {
  //       this.activate(el);
  //     } else {
  //       observer.observe(el);
  //     }
  //   });
  // }

  // テキスト要素にアクティブクラスを付与する
  activate(el) {
    el.classList.add(this.activeClassName);
  }

  // js-scroll-txt-layer-parent 要素の下端が画面下から layerBottomTriggerRatio の位置に入ったら
  // 残りの data-scroll-txt 要素を stagger 表示する
  // observeLayerBottom(container) {
  //   const layerParent = container.querySelector('.js-scroll-txt-layer-parent');
  //   if (!layerParent) return;

  //   // layerParent 下端に sentinel を生成（高さがビューポートより大きい要素の下端検知のため）
  //   const sentinel = document.createElement('span');
  //   sentinel.style.cssText = 'display:block;position:absolute;bottom:0;left:0;width:1px;height:1px;pointer-events:none;';
  //   layerParent.appendChild(sentinel);

  //   const observer = new IntersectionObserver(
  //     (entries) => {
  //       entries.forEach((entry) => {
  //         if (entry.isIntersecting) {
  //           const restEls = layerParent.querySelectorAll(`[data-scroll-txt]:not(.${this.activeClassName})`);
  //           this.activateRemaining(restEls);
  //           observer.disconnect();
  //           sentinel.remove();
  //         }
  //       });
  //     },
  //     { rootMargin: `0px 0px -${this.layerBottomTriggerRatio * 100}% 0px`, threshold: 0 }
  //   );

  //   observer.observe(sentinel);
  // }

  // 未アクティブな要素を stagger 付きでアクティブ化する
  // activateRemaining(els) {
  //   els.forEach((el, i) => setTimeout(() => this.activate(el), this.staggerDelay * i));
  // }

  // スティッキーレイヤーの初期化（position 管理を JS に委譲）
  initStickyLayer(container) {
    const layer = container.querySelector('.js-scroll-txt-layer');
    if (!layer) return;

    const parent = layer.parentElement;
    const update = () => this.updateLayerPosition(layer, parent);
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  // スクロール位置に応じてレイヤーのポジションを切り替える
  updateLayerPosition(layer, parent) {
    const parentRect = parent.getBoundingClientRect();

    if (parentRect.top > 0) {
      // sticky ゾーン前: インラインスタイルをクリアして CSS の設定に準拠
      layer.style.position = '';
      layer.style.top = '';
      layer.style.left = '';
      layer.style.width = '';
    } else if (parentRect.bottom > window.innerHeight) {
      // sticky ゾーン: viewport 上部に固定
      layer.style.position = 'fixed';
      layer.style.top = '0';
      layer.style.bottom = '';
      layer.style.left = `${parentRect.left}px`;
      layer.style.width = `${parentRect.width}px`;
    } else {
      // sticky ゾーン後: 親要素の末尾に追従
      layer.style.position = 'absolute';
      layer.style.top = 'auto';
      layer.style.left = '0';
      layer.style.bottom = '0';
      layer.style.width = '100%';
    }
  }
}

export default ScrollTxt;
